// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconWarning = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 24 24' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M12 3c.554 0 1.066.301 1.347.796l8.438 14.785c.285.498.285 1.113.008 1.611a1.56 1.56 0 0 1-1.356.808H3.561c-.558 0-1.078-.31-1.355-.808a1.65 1.65 0 0 1 .007-1.61l8.439-14.786A1.55 1.55 0 0 1 11.998 3m0 5.143c-.52 0-.938.43-.938.964v4.5c0 .535.418.964.937.964s.938-.43.938-.964v-4.5a.95.95 0 0 0-.938-.964m1.25 9c0-.711-.56-1.286-1.25-1.286-.692 0-1.25.575-1.25 1.286s.558 1.286 1.25 1.286c.69 0 1.25-.575 1.25-1.286'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconWarning)
const Memo = memo(ForwardRef)
export default Memo
